import { CurrencyCode } from "../types/currency";
import useUserData from "./useUserData";

function useCurrency(): CurrencyCode {
    const userData = useUserData();
    return userData.currencyCode;
}

export default useCurrency;